import {
	Circle,
	Fill,
	Icon,
	Stroke,
	Style,
	Text
} from 'ol/style.js';
import Static from 'ol/source/ImageStatic.js';
import { transformExtent } from 'ol/proj';
import ImageLayer from 'ol/layer/Image.js';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';

let _cache = {};

export function clearMarkerCache() {
	_cache = {};
}

export function getMarker(key) {
	if (Array.isArray(key))
		return key.map(k => _cache[k]);
	else
		return _cache[key];
}

export function circleMarkerUI(info) {
	const key = ['c', info.radius, info.stroke, info.fill].join('-');
	let m = _cache[key];
	if (m)
		return key;

	let x = new Style({
		image: new Circle({
			radius: info.radius || 8,
			stroke: new Stroke({ color: info.stroke || 'rgba(100,100,100,0.8)' }),
			fill: new Fill({ color: info.fill || "rgba(0,250,0,0.7)" })
		})
	});
	_cache[key] = x;
	return key;
}

export function imageMarkerUI(info) {
	const key = ['i', info.src, info.rotation].join('-');
	let m = _cache[key];
	if (m)
		return key;

	let x = new Style({
		image: new Icon({
			src: info.src,
			rotation: info.rotation == null ? 0 : ((info.rotation - 180) * Math.PI) / 180  //Convert to radians
		})
	});
	_cache[key] = x;
	return key;
}

export function textMarkerUI(info) {
	const key = ['t', info.font, info.fill, info.stroke, info.offsetY].join('-');
	let m = _cache[key];
	if (m)
		return key;

	let x = new Style({
		text: new Text({
			font: info.font || '14px Calibri,sans-serif',
			overflow: true,
			fill: new Fill({
				color: info.fill || '#000'
			}),
			stroke: new Stroke({
				color: info.stroke || '#fff',
				width: 5
			}),
			offsetY: info.offsetY == null ? -15 : info.offsetY
		})
	});
	_cache[key] = x;
	return key;
}

export function imageLayers(data, extents) {
    let imageLayers = [];
    for (let i = 0; i < data.length; i++) {
        let imgUrl = data[i].url;
        let extent = [
            extents[i]?.bounds[0][0],
            extents[i]?.bounds[1][1],
            extents[i]?.bounds[1][0],
            extents[i]?.bounds[0][1]
        ];

        extent = transformExtent(extent, 'EPSG:4326', 'EPSG:3857');

        let imageLayer = new ImageLayer({
            source: new Static({
                url: imgUrl,
                imageExtent: extent,
            }),
        });

        imageLayers.push(imageLayer);
    }

    return imageLayers;
}

export function polygonLayers(data) {

	const styles = [
		new Style({
		  stroke: new Stroke({
			color: 'red',
			width: 3,
		  }),
		  fill: new Fill({
			color: 'rgba(10, 0, 0, 0.1)',
		  }),
		}),
	  ];

	const features = (new GeoJSON()).readFeatures(data, {featureProjection: 'EPSG:3857'});
	const source = new VectorSource({
			features: features
	});
	const vectorLayer = new VectorLayer({
			source: source,
			style: styles,
	});
	return vectorLayer;
}
